import React from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { AddEditCompanyForm } from "../../components/superadmin";
import { PageHeader } from "../../components/v3";

export const AddEditCompany = () => {
  const { id } = useParams();

  return (
    <PageLayout>
      {/* header section */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader
          // title
          title={id ? "Edit Company" : "Add Company"}
        />
      </Box>

      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <AddEditCompanyForm companyId={id} />
      </Box>
    </PageLayout>
  );
};
